module.exports = __webpack_public_path__ + "img/25.6f582617.gif";